export default __webpack_public_path__ + "static/media/Encampment.6da823c5.jpg";